var _defs, _path, _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDeskBg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Component_411_1",
    "data-name": "Component 411 \\u2013 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 410,
    height: 238,
    viewBox: "0 0 410 238",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4910",
    "data-name": "Path 4910",
    d: "M16,0H394a16,16,0,0,1,16,16V222a16,16,0,0,1-16,16H16A16,16,0,0,1,0,222V16A16,16,0,0,1,16,0Z",
    transform: "translate(1022 71)",
    fill: "#8b3b3b"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-2"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_946",
    "data-name": "Rectangle 946",
    width: 325.914,
    height: 380.58,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-3"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_945",
    "data-name": "Rectangle 945",
    width: 337.528,
    height: 332.264,
    fill: "none"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_4909",
    "data-name": "Path 4909",
    d: "M16,0H394a16,16,0,0,1,16,16V222a16,16,0,0,1-16,16H16A16,16,0,0,1,0,222V16A16,16,0,0,1,16,0Z",
    fill: "#68CAEF"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Mask_Group_24",
    "data-name": "Mask Group 24",
    transform: "translate(-1022 -71)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3674",
    "data-name": "Group 3674",
    transform: "translate(766 575.83) rotate(-87)",
    style: {
      isolation: "isolate"
    }
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_3670",
    "data-name": "Group 3670",
    transform: "translate(238.073 319.979)",
    clipPath: "url(#clip-path-2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4908",
    "data-name": "Path 4908",
    d: "M316.416,226.6c-15.113,81.382-45.352,135.724-82.009,149.17-36.691,15.058-80.061-7.307-122.267-37.972a1161.315,1161.315,0,0,1-94.118-77.661C-.949,241.6-5.892,232.85,7.759,219.342c13.658-13.41,43.276-33,80.41-67.633,37.114-33.1,81.9-83.713,125.469-120.784,43.56-37.344,77.36-43.4,95.91-4.143,18.63,37.029,21.957,119.111,6.867,199.814",
    transform: "translate(0 0.001)",
    fill: "#fff",
    opacity: 0.1
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Group_3673",
    "data-name": "Group 3673",
    transform: "translate(1231.216 77.362)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3668",
    "data-name": "Group 3668",
    transform: "translate(-31 -48)",
    clipPath: "url(#clip-path-3)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4907",
    "data-name": "Path 4907",
    d: "M329.225,175.671c-14.4,55.185-45.391,100.967-83.864,127.475-38.473,27-84.424,34.732-128.734,25.23-44.309-9.662-78.589-32.652-98.192-58.131C-1.168,244.21-6.094,215.686,8.3,182.066c14.4-33.472,45.392-68.421,83.864-101.785C130.64,47.53,176.591,16.364,220.9,4.575c44.31-12.079,78.589.108,98.192,32.437,19.6,31.789,24.529,83.721,10.132,138.659",
    transform: "translate(0 0)",
    fill: "rgba(255,255,255,0.1)"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeskBg);
export default __webpack_public_path__ + "static/media/desk-bg.b7aa3d60ba4f202068154a1a9525868c.svg";
export { ForwardRef as ReactComponent };